import { ContentManagerGuard } from "../../guards/permission.guard";
import { Routes } from "@angular/router";
import { ContentControlAssetsHubComponent } from "./assets-hub/content-control-assets-hub/content-control-assets-hub.component";
import { ContentControlOperationRoomComponent } from "./operation-room/content-control-operation-room.component";

export const ContentControlRoutes: Routes = [
  {
    path: "content-control/hub",
    canActivate: [ContentManagerGuard],
    component: ContentControlAssetsHubComponent,
  },
  {
    path: "content-control/operation-room",
    canActivate: [ContentManagerGuard],
    component: ContentControlOperationRoomComponent,
  },
];
